import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common/States";
import UsersTab from "@/components/users/UsersTab";
import RoleMatrix from "@/components/users/RoleMatrix";

export default function Users() {
  return (
    <div data-testid="users-page">
      <PageHeader title="Kullanıcılar" subtitle="Kullanıcı hesapları ve rol bazlı yetki matrisi" testid="users-title" />
      <Tabs defaultValue="users">
        <TabsList className="mb-4">
          <TabsTrigger value="users" data-testid="tab-users">Kullanıcılar</TabsTrigger>
          <TabsTrigger value="roles" data-testid="tab-roles">Rol Yetki Matrisi</TabsTrigger>
        </TabsList>
        <TabsContent value="users"><UsersTab /></TabsContent>
        <TabsContent value="roles"><RoleMatrix /></TabsContent>
      </Tabs>
    </div>
  );
}
